<template>
  <div class="rotate-180 sm:px-6 sm:py-4">
    <Icon
      name="common/arrow-long"
      class="text-3xl font-extrabold text-white"
    />
  </div>
</template>
